import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../utils/utils';
import { environment } from 'src/environments/environment';

@Injectable()
export class SolicitacaoMovimentacaoContratualService {

    routePrefix: string = 'MovimentacaoContratual'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(id = ''): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarSolicitacao${this.routePrefix}`, { GestorId: id})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    pesquisarPorUsuarioId(id = ''): Observable<any> {
      return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarSolicitacao${this.routePrefix}PorUsuarioId?usuarioId=${id}`)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    BuscarSolicitacaoMovimentacaoContratual

    solicitar(data = {}): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/Solicitar${this.routePrefix}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    buscarDadosPorColaboradorId(id = ''): Observable<any> {
        return this.httpClient.get<any>(`${environment.urlBase}${this.routePrefix}/BuscarDados${this.routePrefix}PorColaboradorId?id=${id}`)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

}
